// viewsLogic.js

// Fetch CREATE VIEW statement for a given view
export const fetchCreateViewSQL = async (
  viewName,
  axiosWithToken,
  BASE_URL
) => {
  try {
    const sqlQuery = { query: `SHOW CREATE VIEW ${viewName}` };
    const response = await axiosWithToken.post(`${BASE_URL}dynamic`, sqlQuery);
    const createSQL = response?.data?.[0]?.[`Create View`] || "";
    return createSQL;
  } catch (error) {
    console.error(`Error fetching CREATE VIEW for ${viewName}:`, error);
    return "";
  }
};

// Extract the SELECT statement from CREATE VIEW SQL
export const extractSelectFromCreateView = (createSQL) => {
  const match = createSQL.match(/AS\s+(SELECT[\s\S]*);?$/i);
  return match ? match[1].trim() : "";
};

// Create views metadata table
export const createViewsMetaTable = (db) => {
  db.run(`
    CREATE TABLE IF NOT EXISTS views (
      viewName TEXT PRIMARY KEY,
      sqlQuery TEXT NOT NULL
    );
  `);
};

// Insert or update a view in the views table
export const insertViewIntoMetaTable = (db, viewName, sqlQuery) => {
  const stmt = db.prepare(`
    INSERT OR REPLACE INTO views (viewName, sqlQuery) VALUES (?, ?)
  `);
  stmt.run([viewName, sqlQuery]);
  stmt.free();
};

// Main function to fetch and store all views
export const fetchAndStoreViews = async (
  db,
  viewNames,
  axiosWithToken,
  BASE_URL
) => {
  createViewsMetaTable(db);

  for (const viewName of viewNames) {
    const createSQL = await fetchCreateViewSQL(
      viewName,
      axiosWithToken,
      BASE_URL
    );
    if (!createSQL) continue;

    const selectSQL = extractSelectFromCreateView(createSQL);
    if (selectSQL) {
      insertViewIntoMetaTable(db, viewName, selectSQL);
    } else {
      console.warn(`SELECT statement not found in view: ${viewName}`);
    }
  }
};
